var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fe-flex fe-items-center fe-bg-primary-grey-20 fe-p-xs fe-rounded-medium fe-text-body-xs lg:fe-text-body-s fe-text-primary-grey-80"},[_c('JdsIcon',{attrs:{"name":"WarningIcon","size":"m","color":"fe-text-primary-50","className":"fe-mr-xs"}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }